import React from 'react';

/**
 * 공통 가이드 박스 컴포넌트
 * 프로젝트 상세보기 모달에서 사용
 */
const CommonGuideBox = () => {
  return (
    <div className="project-preview-modal__common-guide">
      <div className="project-preview-modal__common-guide-header">
        <span className="project-preview-modal__common-guide-icon">📋</span>
        <h3 className="project-preview-modal__common-guide-title">공통 가이드</h3>
      </div>
      <ul className="project-preview-modal__common-guide-list">
        <li>선정 후, 계약 시 결과물을 기한 내 업로드 해주셔야 합니다. 정상적으로 진행되지 않을 시, 셀프애드 이용이 제한됩니다.</li>
        <li>결과물(광고 콘텐츠)의 최소 게시 유지 기간은 3개월입니다. 3개월 이상 콘텐츠를 유지해주셔야 합니다.</li>
        <li>보상을 받는 콘텐츠의 경우 보상을 받고 리뷰를 진행하는 것임을 명시해주세요.</li>
        <li>프로젝트에 선정되고, 문의 사항이 생길 시, 셀프애드를 통해 문의해주시면 됩니다.</li>
        <li>콘텐츠는 반드시 프로젝트 지원시 선택한 SNS 계정에 업로드 되어야합니다.</li>
        <li>제품을 제공받고 업로드를 하지 않는 경우, 콘텐츠가 제대로 게시되지 않는 경우 등 고의 또는 부주의로 인해 비정상적으로 프로젝트가 진행될 시 피해 금액이 위약금으로 부과됩니다.</li>
      </ul>
    </div>
  );
};

export default CommonGuideBox;
